import Text from 'src/components/atoms/Text';
import Modal, { ModalVariant } from 'src/components/organisms/Modal';

interface IDisableOwnerModalProps {
  linkedPropertiesCount?: number;
  isOpen: boolean;
  onConfirm: () => void;
  isUpdateLoading: boolean;
  closeModal: () => void;
}

const DisableOwnerModal = ({
  linkedPropertiesCount,
  isOpen,
  onConfirm,
  isUpdateLoading,
  closeModal
}: IDisableOwnerModalProps) => {
  return (
    <Modal
      title="Disable Owner"
      labelButtonCancel="Cancel"
      labelButtonConfirm="Disable"
      showModal={isOpen}
      isBackClosable={false}
      isEscapeClosable={false}
      isDisabledButtonCancel={isUpdateLoading}
      isDisabledButtonConfirm={isUpdateLoading}
      isLoadingButtonConfirm={isUpdateLoading}
      variant={ModalVariant.danger}
      onConfirm={() => {
        onConfirm();
      }}
      onCancel={closeModal}
      data-testid="disable-owner-modal"
    >
      <Text>
        {linkedPropertiesCount === 0 || linkedPropertiesCount === undefined
          ? ''
          : `There are ${linkedPropertiesCount} linked properties as part of this Owner. Disabling will
        remove them from the group.`}
        Are you sure you want to proceed?
      </Text>
    </Modal>
  );
};

export default DisableOwnerModal;
